<template>
  <div class="layout">
    <aside class="sidebar">
      <div class="logo">
        <h2>Code Mini</h2>
        <span>管理后台</span>
      </div>
      <ul class="menu">
        <li
          v-for="item in menuItems"
          :key="item.path"
          :class="{ active: currentPath.startsWith(item.path) }"
          @click="navigate(item.path)"
        >
          <span class="menu-icon">{{ item.icon }}</span>
          <span>{{ item.label }}</span>
        </li>
      </ul>
      <div class="sidebar-footer">
        <span class="user-info">{{ userInfo ? userInfo.nickname : '管理员' }}</span>
        <span class="logout-btn" @click="handleLogout">退出登录</span>
      </div>
    </aside>
    <main class="main-content">
      <div class="page-header">
        <h2>{{ currentTitle }}</h2>
      </div>
      <div class="page-body">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import { removeToken, getUserInfo } from '../api/index';

export default {
  name: 'Layout',
  data() {
    return {
      userInfo: null,
      menuItems: [
        { path: '/articles', label: '套餐专区', icon: '📄' },
        { path: '/products', label: '单品资料', icon: '📦' },
        { path: '/free', label: '免费专区', icon: '🎁' },
        { path: '/categories', label: '分类管理', icon: '📂' },
        { path: '/settings', label: '系统设置', icon: '⚙️' },
      ],
    };
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
    currentTitle() {
      const route = this.$route;
      if (route.meta && route.meta.title) {
        return route.meta.title;
      }
      return '';
    },
  },
  created() {
    this.userInfo = getUserInfo();
  },
  methods: {
    navigate(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    handleLogout() {
      removeToken();
      this.$router.push('/login');
    },
  },
};
</script>

<style scoped>
.layout {
  display: flex;
  min-height: 100vh;
}

.sidebar {
  width: 220px;
  background: #001529;
  color: #fff;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.logo {
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.logo h2 {
  font-size: 20px;
  color: #fff;
}

.logo span {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  display: block;
  margin-top: 4px;
}

.menu {
  flex: 1;
  list-style: none;
  padding: 12px 0;
}

.menu li {
  display: flex;
  align-items: center;
  padding: 12px 24px;
  cursor: pointer;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.65);
  transition: all 0.3s;
}

.menu li:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

.menu li.active {
  color: #fff;
  background: #1677FF;
}

.menu-icon {
  margin-right: 10px;
  font-size: 16px;
}

.sidebar-footer {
  padding: 16px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
}

.logout-btn {
  cursor: pointer;
  color: #ff4d4f;
}

.logout-btn:hover {
  text-decoration: underline;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page-header {
  height: 56px;
  padding: 0 24px;
  background: #fff;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.page-header h2 {
  font-size: 18px;
  font-weight: 500;
  color: #333;
}

.page-body {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
}
</style>
